import React from 'react';
import { motion } from 'framer-motion';
import { MineralCard } from './MineralCard';
const minerals = [{
  id: 1,
  name: 'Premium Gold Bars',
  category: 'Gold',
  price: 'Contact for Quote',
  description: 'Certified 24K gold bars sourced from RDC mines. Available in various weights with full documentation and authenticity certificates.',
  image: 'https://cdn.magicpatterns.com/uploads/9yViD7iNBMQrDT7YKPiuPN/cheapest-gold-in-africa.jpg'
}, {
  id: 2,
  name: 'Natural Gold Nuggets',
  category: 'Gold',
  price: 'Contact for Quote',
  description: 'Raw gold nuggets in their natural form. Each piece is unique with exceptional purity, ethically mined from certified RDC operations.',
  image: 'https://cdn.magicpatterns.com/uploads/1xEw7Sy3SvgN8xy9sTHHWZ/305187130_401176575504178_5481572184447334124_n.jpg'
}, {
  id: 3,
  name: 'Certified Diamonds',
  category: 'Diamonds',
  price: 'Contact for Quote',
  description: 'High-quality diamonds from RDC mines. Conflict-free certified with full traceability and international grading reports.',
  image: 'https://cdn.magicpatterns.com/uploads/1pU4bvPgUksBkJinbXdoGY/second-largest-diamond-discovered.webp'
}, {
  id: 4,
  name: 'Rough Diamonds',
  category: 'Diamonds',
  price: 'Contact for Quote',
  description: 'Uncut rough diamonds for industrial and jewelry applications. Ethically sourced with complete chain of custody documentation.',
  image: 'https://cdn.magicpatterns.com/uploads/tC3nm9nnzV9vV2Qn11C4Xm/second-largest-diamond-discovered.webp'
}, {
  id: 5,
  name: 'Precious Gemstones',
  category: 'Gemstones',
  price: 'Contact for Quote',
  description: 'Rare gemstones including emeralds, sapphires, and tourmalines. Sourced from RDC mineral-rich regions with authenticity guarantees.',
  image: 'https://cdn.magicpatterns.com/uploads/5M5c6p9Sa7g4kMUUJXkFdR/eyJidWNrZXQiOiJjb250ZW50Lmhzd3N0YXRpYy5jb20iLCJrZXkiOiJnaWZcL3NodXR0ZXJzdG9jay0yMjQ4ODAxNjI1LWhlcm8uanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjo4Mjh9fX0.webp'
}, {
  id: 6,
  name: 'Semi-Precious Stones',
  category: 'Gemstones',
  price: 'Contact for Quote',
  description: 'Quality semi-precious stones including amethyst, citrine, and garnet. Perfect for jewelry manufacturing and collectors.',
  image: 'https://cdn.magicpatterns.com/uploads/mjZRvdK2SN2vNLvHDwNYgv/images_(2).jpg'
}];
export function MineralShowcase() {
  return <section id="collection" className="py-24 bg-gray-50" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-167">
            Our Minerals
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-168">
            Specializing in Gold, Diamonds, and Gemstones. All minerals are
            ethically sourced, certified, and come with complete documentation.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-169">
          {minerals.map((mineral, index) => <motion.div key={mineral.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-170">
              <MineralCard {...mineral} data-id="element-171" />
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-172">
          <button className="inline-flex items-center px-8 py-3 border border-gray-300 text-base font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 hover:text-drc-blue transition-colors duration-300" data-id="element-173">
            View Full Catalog
          </button>
        </div>
      </div>
    </section>;
}